<div class="wrap">
  <div class="infos" *ngIf=" userisLink? userFirstNameLink : userLastName ">
    <div class="infos_img">
      <div class="img">
        <ion-avatar><img [src]="userPhoto?.changingThisBreaksApplicationSecurity" [alt]="userFirstName + userLastName">
        </ion-avatar>
        <input type="file" class="upload_photo" value="Modifier" *ngIf="update" (change)="sendFile($event)">
        <div class="change_photo" *ngIf="update">
          Modifier
        </div>
      </div>
    </div>

    <div class="infos_content">
      <h3>{{ userisLink? userLastNameLink: userLastName | uppercase}}
        <span>{{ userisLink? userFirstNameLink: userFirstName | lowercase}}</span>
      </h3>
      <p class="season">Nombre de saison : {{ userisLink? userSenoriotyLink: 0 }}</p>
      <p> <img src="assets/img/club_profif.svg" alt="club_sportif"><span>Club :</span>
        {{ userClubLink || '-'}}</p>
    </div>
    <!-- <div class="infos_content" *ngIf="userisLink">
      <h3>{{ userLastNameLink | uppercase}}
        <span>{{ userFirstNameLink | lowercase}}</span></h3>
      <p class="season">Nombre de saison : {{ userSenoriotyLink }}</p>
      <p> <img src="assets/img/club_profif.svg" alt="club_sportif"><span>Club :</span>
        {{ userClubLink }}</p>
    </div>
    <div class="infos_content" *ngIf="!userisLink ">
      <h3>{{ userLastName  | uppercase}}
        <span>{{ userFirstName | lowercase}}</span>
      </h3>
      <p class="season">Nombre de saison : 0</p>
      <p> <img src="assets/img/club_profif.svg" alt="club_sportif"><span>Club : </span> --</p>
    </div> -->
  </div>

  <app-skeleton-profile *ngIf="userisLink? !userFirstNameLink : !userLastName"></app-skeleton-profile>

  <div class="update" *ngIf="!update && show && !myClub && !wallOfTrophy && !showMyLicence && !showMySkills">
    <span (click)="goToUpdate()">Modifier mes infos</span>
  </div>
  <div class="connexion" *ngIf="!wallOfTrophy && !showMyLicence && !showMySkills">
    <mat-slide-toggle [(ngModel)]="isChecked" [color]="color" (click)="this.getStatusConnect()">
      Rester connecté
    </mat-slide-toggle>
  </div>

  <div class="btn_action">
    <app-menu-profil
      *ngIf="show && !update && !myClub && !unlink && !confirmEmailLicence && !wallOfTrophy && !showMyLicence && !showMySkills"
      [@menu]>
    </app-menu-profil>
    <app-update-password *ngIf="!show && !update && !myClub" && !wallOfTrophy [@update]></app-update-password>
    <app-update-profil *ngIf="update" [@update]></app-update-profil>
    <app-my-club *ngIf="myClub" [userDetails]="userDetails" [@update]></app-my-club>
    <app-confirm-unlink *ngIf="unlink" [@update]> </app-confirm-unlink>
    <app-confirm-email-licence *ngIf="confirmEmailLicence" [@update]></app-confirm-email-licence>
    <app-wall-of-trophy *ngIf="wallOfTrophy" [@update]></app-wall-of-trophy>
    <app-my-licence *ngIf="showMyLicence" [@update]></app-my-licence>
    <app-my-skills *ngIf="showMySkills" [@update]></app-my-skills>
  </div>
</div>